<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="m-0 pt-20">{{ titleText }}</h1>
      <ol class="breadcrumb mb-10 pl-0">
        <li><router-link :to="{ name: 'list-versions' }">Dashboard</router-link></li>
        <template v-if="$route.name == 'participant-results'">
          <li><router-link :to="{ name: 'results' }">Results</router-link></li>
          <li>{{ titleText }}</li>
        </template>
        <template v-else>
          <li>Results</li>
        </template>
      </ol>
      <!-- <div class="full-height-builder pages-container"> -->
        <transition name="fade" mode="out-in" v-if="isReady">
          <router-view></router-view>
        </transition>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex';
  export default {
    name: 'Results',
    async created() {
      await this.getAuthorProjects();
      await this.getAllVersions();
      this.isReady = true;
    },

    data() {
      return {
        isReady: false,
      };
    },

    async mounted() {},

    methods: {
      ...mapActions('versions', ['getAuthorProjects', 'getAllVersions']),
    },

    computed: {
      ...mapState('versions', ['authorProjects', 'isLoading','versions']),
      titleText() {
        if (this.$route.name == 'participant-results' && this.$route.params?.resourceKey) {
          const temp = this.authorProjects.find(
            (e) => e.versionKey == this.$route.params?.resourceKey
          );
          return  this.versions[this.$route.params.resourceKey]?.versionName
         
          // return temp?.versionName;
        } else return 'Results';
      },
    },
  };
</script>
<style lang="scss" scoped>
  @media print {
    .pages-container {
      overflow: auto !important;
      width: 100% !important;
    }
  }
  .pages-container {
    overflow-y: auto;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
</style>
